module.exports = __webpack_public_path__ + "b5a91fa7bbafc600f69ba954bc0e69cc.svg";